export const PRODUCTS = {
  PRODUCTS: 'PRODUCTS',
  PRODUCT_IDA: 'PRODUCT_IDA',
};
